module.exports = __webpack_public_path__ + "img/35.311c2157.jpg";